module.exports = {"redLighter":"rgb(237,160,165)","cyanLighter":"rgb(149,204,214)","greenLighter":"rgb(192,214,182)","brownLighter":"rgb(237,223,204)","grayLighter":"rgb(226,226,226)","redLight":"rgb(226,103,122)","cyanLight":"rgb(0,181,196)","greenLight":"rgb(149,187,137)","brownLight":"rgb(225,202,172)","grayLight":"rgb(200,200,200)","red":"rgb(219,18,74)","cyan":"rgb(0,145,163)","green":"rgb(101,168,94)","brown":"rgb(212,180,136)","gray":"rgb(178,178,178)","redDark":"rgb(139,0,40)","cyanDark":"rgb(0,103,115)","greenDark":"rgb(94,141,91)","brownDark":"rgb(159,135,95)","grayDark":"rgb(130,130,130)"}


//////////////////
// WEBPACK FOOTER
// ./src/mot-colors.json
// module id = 6
// module chunks = 0